import React from 'react';
import { Linking, Pressable, StyleSheet, Text, View } from 'react-native';

export default function BillingModalFooter({ summary }) {
  const supportRef = summary?.supportReferenceId;
  return (
    <View style={styles.root}>
      <Text style={styles.legal}>
        Subscriptions are billed securely by Paddle. You can manage or cancel at any time from this modal.
      </Text>
      {supportRef && (
        <Text style={styles.ref}>Ref: {supportRef}</Text>
      )}
      <Pressable
        accessibilityRole="link"
        onPress={() => Linking.openURL('mailto:support@doocars.com?subject=Billing%20support')}
        style={({ pressed }) => [styles.support, pressed && { opacity: 0.6 }]}
      >
        <Text style={styles.supportText}>Email support@doocars.com</Text>
      </Pressable>
    </View>
  );
}

const styles = StyleSheet.create({
  root: { paddingHorizontal: 20, paddingTop: 14, paddingBottom: 20, borderTopWidth: 1, borderTopColor: 'rgba(255,255,255,0.08)', gap: 8 },
  legal: { fontSize: 12, color: 'rgba(255,255,255,0.5)', lineHeight: 16 },
  ref: { fontSize: 11, color: 'rgba(255,255,255,0.35)', fontFamily: 'monospace' },
  support: { paddingVertical: 4 },
  supportText: { fontSize: 13, fontWeight: '600', color: '#6FA0FF' },
});
